import { gsap, Linear } from 'gsap';
import { EventEmitter } from "events";
import { MIN_VOLUME } from "@/constants";
export class BasePlayer extends EventEmitter {
    constructor({ path, name, input, config }) {
        super();
        this.isConnected = false;
        this._name = name.toUpperCase() || `BasePlayer-${path}-${Math.ceil(Math.random() * 1000)}`;
        this.path = path;
        this.input = input;
        // Fallback to blank config if not supplied
        this.config = config || {};
    }
    /**
     * Handle the operations when entering a scene
     */
    enterScene(scene, targetVolume) {
        var _a;
        if (this.player.loaded && this.player.state === "stopped") {
            this.player.start();
        }
        const volume = targetVolume || this.config.volume || -6;
        const duration = ((_a = scene.fadeInDuration) !== null && _a !== void 0 ? _a : this.config.fadeInDuration) || 2;
        if (duration > 0) {
            this.fadeVolumeTo({ volume, duration });
        }
        else {
            this.player.volume.value = volume || -6;
        }
    }
    /**
     * Handle the operations when exiting a scene
     */
    exitScene(scene) {
        var _a;
        this.fadeVolumeTo({ volume: -128, duration: ((_a = scene.fadeOutDuration) !== null && _a !== void 0 ? _a : this.config.fadeOutDuration) || 2 });
    }
    fadeVolumeTo({ volume, duration = undefined }) {
        gsap.killTweensOf(this.player.volume);
        // Ensure we have a finite value when fading in
        if (this.player.volume.value < MIN_VOLUME) {
            this.player.volume.value = MIN_VOLUME;
        }
        gsap.to(this.player.volume, {
            value: volume,
            duration: duration || 2,
            ease: Linear.easeNone,
        });
    }
    /**
     * Stop all audio
     */
    stopAll() {
        this.player.stop();
    }
    connect(node) {
        this.player.connect(node);
        this.isConnected = true;
        return this;
    }
    /**
     * Disconnect the player from the audio graph
     */
    disconnect() {
        this.player.disconnect();
        this.player.dispose();
        this.isConnected = false;
    }
    get connected() {
        return this.isConnected;
    }
    get name() {
        return this._name;
    }
}
